export default __webpack_public_path__ + "static/media/g2-rating.0b060fec.svg";